export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '\u{1F1EC}\u{1F1E7}', dir: 'ltr' },
  { code: 'tr', label: 'T\u00FCrk\u00E7e', flag: '\u{1F1F9}\u{1F1F7}', dir: 'ltr' },
  { code: 'ru', label: '\u0420\u0443\u0441\u0441\u043A\u0438\u0439', flag: '\u{1F1F7}\u{1F1FA}', dir: 'ltr' },
  { code: 'de', label: 'Deutsch', flag: '\u{1F1E9}\u{1F1EA}', dir: 'ltr' },
  { code: 'es', label: 'Espa\u00F1ol', flag: '\u{1F1EA}\u{1F1F8}', dir: 'ltr' },
  { code: 'it', label: 'Italiano', flag: '\u{1F1EE}\u{1F1F9}', dir: 'ltr' },
  { code: 'ar', label: '\u0627\u0644\u0639\u0631\u0628\u064A\u0629', flag: '\u{1F1F8}\u{1F1E6}', dir: 'rtl' }
] as const;

export type LanguageCode = typeof LANGUAGES[number]['code'];
